import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.secondSection.loading;
export const secondSectionStatusErrorMessage = (state: RootState) =>
  state.secondSection.error;
export const secondSectionDataResponse = (state: RootState) =>
  state.secondSection.secondSectionResponse;
